/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: @loopback/repository-json-schema#Optional<Omit<Interaction, \'id\'>, \'publicationId\'>, schemaOptions: { title: \'NewInteractionInPublication\', exclude: [ \'id\' ], optional: [ \'publicationId\' ] })
 */
export interface NewInteractionInPublication { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    type: NewInteractionInPublication.TypeEnum;
    publicationId?: string;
    userId: number;
}
export namespace NewInteractionInPublication {
    export type TypeEnum = 'LIKE' | 'WELCOME' | 'CONGRATULATION';
    export const TypeEnum = {
        Like: 'LIKE' as TypeEnum,
        Welcome: 'WELCOME' as TypeEnum,
        Congratulation: 'CONGRATULATION' as TypeEnum
    };
}


